import React from 'react';

/**
 * ÐÐ°Ð³ÑÑÐ·ÐºÐ° Ð¿Ð¾Ð²ÐµÑÑ ÑÐºÑÐ°Ð½Ð° Ñ Ð¿Ð¾Ð½ÑÑÐ½Ð¾Ð¹ Ð¿Ð¾Ð´Ð¿Ð¸ÑÑÑ: ÑÑÐ¾ Ð¸Ð¼ÐµÐ½Ð½Ð¾ ÑÐµÐ¹ÑÐ°Ñ Ð´ÐµÐ»Ð°ÐµÑÑÑ.
 * ÐÐ»Ð¾ÐºÐ¸ÑÑÐµÑ Ð¿Ð¾Ð²ÑÐ¾ÑÐ½ÑÐµ Ð½Ð°Ð¶Ð°ÑÐ¸Ñ â Ð¿Ð¾ÐºÐ° Ð¸Ð´ÑÑ Ð·Ð°Ð¿ÑÐ¾Ñ, ÑÐ¾ÑÐ¼Ð° Ð½ÐµÐ´Ð¾ÑÑÑÐ¿Ð½Ð°.
 */
const BusyOverlay = ({ text, hint = 'Ð­ÑÐ¾ Ð·Ð°Ð¹Ð¼ÑÑ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ ÑÐµÐºÑÐ½Ð´' }) => (
  <div
    role="status"
    aria-live="polite"
    style={{
      position: 'fixed',
      inset: 0,
      zIndex: 2000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(255, 255, 255, 0.72)',
    }}
  >
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 12,
        padding: '28px 40px',
        background: '#fff',
        borderRadius: 14,
        boxShadow: '0 12px 40px rgba(5, 20, 31, 0.18)',
        textAlign: 'center',
      }}
    >
      <svg width="44" height="44" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" fill="none" stroke="#E8E8E8" strokeWidth="2.5" />
        <path d="M12 3a9 9 0 0 1 9 9" fill="none" stroke="var(--brand-primary)" strokeWidth="2.5" strokeLinecap="round">
          <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite" />
        </path>
      </svg>
      <div style={{ fontSize: 17, fontWeight: 600 }}>{text}</div>
      {hint && <div style={{ fontSize: 13, color: '#8B8B8B' }}>{hint}</div>}
    </div>
  </div>
);

export default BusyOverlay;
